module.exports = __webpack_public_path__ + "static/media/bruno-salvadori-2269872.74515e5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/bruno-salvadori-2269872.jpg
// module id = 74
// module chunks = 0